<template>
    <div class="liked">
        <div class="liked-item">
            <liked-product-card/>
        </div>
        <div class="liked-item">
            <liked-product-card/>
        </div>
    </div>
</template>

<script>
    import LikedProductCard from "../Cards/LikedProductCard";
    export default {
        name: "LikedProducts",
        components: {LikedProductCard}
    }
</script>

<style scoped lang="scss">
    .liked {
        background-color: #FCFCFC;
        width: 385px;

        box-shadow: 0 15px 20px rgba(0, 0, 0, 0.04);
        &-item {
            &:not(:last-child) {
                border-bottom: 1px solid #EEF2F6;
            }
        }
    }

</style>